module.exports = __webpack_public_path__ + "img/fuwuhao.582caaaa.jpg";